import React from 'react';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeCard from '../shared/HomeCard';
import { familyDashboardSections } from '../config/familyDashboard';

export default function FamilyDashboard() {
  return (
    <div className="page">
      <Link to="/" className="back-link">
        <ArrowBackIcon fontSize="small" /> Back to Home
      </Link>
      <div className="page-header">
        <h1 className="page-title">Family Dashboard</h1>
        <p className="page-subtitle">Family-based household segmentation, priority index and personas.</p>
      </div>

      <div className="card-grid">
        {familyDashboardSections.map((section) => (
          <HomeCard
            key={section.id}
            to={`/family-dashboard/${section.id}`}
            title={section.title}
            description={section.description}
            icon={section.icon}
            accent={section.accent}
          />
        ))}
      </div>
    </div>
  );
}
